import {useEffect, useRef, useState} from "react";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import ModalLayout from "@/ui/modals/ModalLayout.tsx";
import st from "@/styles/Modals.module.scss";
import CMS from "@/utils/cms.ts";
import {LocalLanguage} from "@/types_and_interfaces/types.ts";
import {useTranslation} from "react-i18next";
import Button from "@/ui/Button.tsx";


const DataConsentModal = () => {
    const [open, set_open] = useState<boolean>(false);
    const effectRan = useRef<boolean>(false);
    const { t, i18n } = useTranslation();
    const raw_data = CMS.general_info
    const data = CMS.langAwareFilter(raw_data, (i18n.language as LocalLanguage))
    
    const {
        data_processing_consent_title,
        data_processing_consent_description
    } = data
    
    const openModal = (x: boolean) => {
        set_open(x);
    };
    
    useEffect(() => {
        if (!effectRan.current) {
            eventEmitter.on(CommonClass.ModalEvents.OpenDataConsent, openModal);
            
            return () => {
                eventEmitter.off(CommonClass.ModalEvents.OpenDataConsent, openModal);
            };
        }
        
        effectRan.current = true;
    }, []);
    
    return (
        <ModalLayout
            className={st.doc_consent_modal}
            open={open}
            innerClassName={st.doc_consent_modal_inner}
            // on_close_state={() => {
            //     set_open(false)
            // }}
            onAfterClose={() => {
                eventEmitter.emit(CommonClass.CustomEvents.show_promo_popups, true)
            }}
            removeClose
        >
            
            <>
                
                <h3 className={st.heading}>
                    {data_processing_consent_title || data_processing_consent_title}
                </h3>
                
                {data_processing_consent_description ? (
                    <div className={st.content} dangerouslySetInnerHTML={{__html: data_processing_consent_description}} />
                ) : null}
                
                <Button
                    onClick={() => {
                        set_open(false)
                    }}
                    className={st.btn}
                >
                    {t("agree")}
                </Button>
            </>
        
        </ModalLayout>
    )
}

export default DataConsentModal